import type { Bucket, ProspectFilters } from '../types';
import type { FilterCounts } from '../../../graphql/fetchProspectsWithPaginationByJobId';
import jobApplicationService from '../../../services/jobApplicationService';
import isFeatureEnabled from '../../../modules/featureToggle/isFeatureEnabled';
import { FEATURE_SEARCH_API } from '../../../modules/featureToggle';
import { logError } from '../../../utils/logError';
import { getSearchTerm } from './getJobApplications';

const getCountsForFilters = async (
  jobId: number,
  searchText: string,
  bucket: Bucket,
  sortBy: string,
  pageNumber: number = 1,
  filters?: ProspectFilters,
): Promise<FilterCounts | undefined> => {
  try {
    const searchQuery = getSearchTerm(searchText);
    const prospectsResult = await jobApplicationService.fetch(
      jobId,
      isFeatureEnabled(FEATURE_SEARCH_API) ? searchText : searchQuery,
      bucket as any,
      sortBy,
      pageNumber,
      filters,
    );

    return prospectsResult.filterCounts;
  } catch (error: any) {
    logError(
      {
        errorCode: 'GET_FILTER_COUNTS',
        description: 'Error attempting: jobApplicationService.fetch',
      },
      {
        error,
        jobId,
        searchApiFeatureEnabled: isFeatureEnabled(FEATURE_SEARCH_API),
        bucket,
        sortBy,
        pageNumber,
        filters,
        searchText,
      },
    );
    return;
  }
};

export default getCountsForFilters;
